import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Trophy"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.8222 1.5C6.09196 1.5 5.49999 2.09197 5.49999 2.8222V4.6505H3.61453C2.99899 4.6505 2.5 5.14949 2.5 5.76503V9.79792C2.5 12.015 4.23713 13.8264 6.42459 13.9453C7.4397 15.6345 9.20075 16.8244 11.2521 17.0594V21.0025H5.50002V22.5025H18.5V21.0025H12.7521V17.0589C14.8015 16.8228 16.5608 15.6334 17.5753 13.9455C19.7647 13.8288 21.5041 12.0165 21.5041 9.79792V5.76503C21.5041 5.14949 21.0051 4.6505 20.3896 4.6505H18.5V2.8222C18.5 2.09197 17.908 1.5 17.1778 1.5H6.8222ZM17 3H6.99999V10.602C6.99999 13.3634 9.23857 15.602 12 15.602C14.7614 15.602 17 13.3634 17 10.602V3ZM5.71928 12.2823C5.57624 11.7463 5.49999 11.1831 5.49999 10.602V6.1505H4V9.79792C4 10.9346 4.71472 11.9044 5.71928 12.2823ZM20.0041 9.79792C20.0041 10.9363 19.2872 11.9073 18.2802 12.2841C18.4236 11.7475 18.5 11.1837 18.5 10.602V6.1505H20.0041V9.79792Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Trophy.vue"]]);
